import { Palette } from '@/themes/themeOverrides/Palette';

export const MuiToolbarStyles = {
    styleOverrides: {
        dense: {
            gap: '20px !important',
        },
        root: {
            '&.RaBulkActionsToolbar-toolbar': {
                backgroundColor: `${Palette.white} !important`,
                position: 'fixed !important',
                top: 'auto !important',
                bottom: 0,
                left: 'auto !important',
                right: 'auto !important',
                height: 'auto !important',
                padding: '32px 40px',
                width: '-webkit-fill-available',
                transform: 'translateY(0px) !important',
                marginLeft: '-40px',
                boxShadow: Palette.boxShadow.elevation12,
                borderTopLeftRadius: '16px',
                borderTopRightRadius: '16px',
                justifyContent: 'flex-start !important',
                flexWrap: 'wrap',
                zIndex: '4 !important',
                ['@media (max-width: 1023px)']: {
                    display: 'none',
                },
                '& RaBulkActionsToolbar-topToolbar': {
                    gap: '16px',
                    padding: '0px',
                },
                '&.RaBulkActionsToolbar-collapsed': {
                    transform: 'translateY(140px) !important',
                },
                '& .RaBulkActionsToolbar-title': {
                    display: 'none',
                    marginRight: '16px',
                    '& .MuiIconButton-root': {
                        display: 'none',
                    },
                    '& .MuiTypography-root': {
                        fontSize: '14px',
                        fontStyle: 'normal',
                        fontWeight: '600',
                        lineHeight: '20px',
                    },
                },
                '& .MuiTypography-subtitle1': {
                    lineHeight: '32px',
                    color: Palette.black,
                },
                '& .MuiButton-textPrimary': {
                    backgroundColor: Palette.gray.gray100,
                    color: `${Palette.black} !important`,
                },
            },
            '&.toolbar--tag-category': {
                '& > .MuiIconButton-root': {
                    display: 'none',
                },
                '& .more-actions': {
                    display: 'flex',
                    position: 'static',
                    background: 'transparent',
                    padding: '0',
                    boxShadow: 'none',
                },
            },
            '& .more-area': {
                '& .MuiPopover-paper': {
                    '& .MuiBox-root.more-content': {
                        padding: '20px',
                        '& .MuiButton-text': {
                            minWidth: '172px',
                            width: '100%',
                            textAlign: 'left',
                            justifyContent: 'left',
                        },
                        '& .MuiButtonBase-root': {
                            '&:hover': {
                                backgroundColor: Palette.yellow.yellow50,
                                boxShadow: 'none',
                            },
                        },
                    },
                },
            },
        },
    },
};
